import React from "react";

// Injects JSON-LD structured data for SEO + AI search/shopping agents.
export const Seo = ({ title, description, jsonLd }) => {
  React.useEffect(() => {
    if (title) document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
    if (description) meta.setAttribute("content", description);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      script.setAttribute("data-seo", "1");
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, jsonLd]);
  return null;
};
